import dayjs from 'dayjs'

export const getDate = (date?: string | null) => {
  if (date) {
    return dayjs(date).format('D MMM YYYY, HH:mm')
  }

  return null
}
